module.exports = __webpack_public_path__ + "img/story040@2x.d526d07d.webp";